import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssignmentIcon from '@material-ui/icons/Assignment';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
// import NoteAddOutlinedIcon from '@material-ui/icons/NoteAddOutlined';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Tooltip, withStyles, MenuProps, Menu, Typography, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { CSVLink } from 'react-csv';

interface TableState {
    columns: Array<Column<RowDataCompleted>>;
    data: RowDataCompleted[];
}

export interface CompleteOrderPageViewDateProps {
    completeOrderDataDate: RowDataCompleted[];
    completeOrderDataExport: RowDataCompleted[];
    isDownloading: boolean;
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (filePath: string, fileName: string) => void;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;
    onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    // onFileName:(fileName: string) => void;
    fDate: (fromDate: Date | null) => void;
    fTime: (fromTime: Date | null) => void;
    toDate: (todate: Date | null) => void;
    toTime: (toTime: Date | null) => void;

    startDate: Date | null;
    endDate: Date | null;
    startTime: Date | null;
    endTime: Date | null;

    dateFilter: () => void;
    dateReset: () => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
     // Add these new properties:
     failedFiles: Array<{ fname: string; orderno: string }>;
     showFailedFilesDialog: boolean;
     failedFilesMessage: string;
     closeFailedFilesDialog: () => void;
}

export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        dialog: {
            margin: theme.spacing(2)
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        exportButton: {
            textDecoration: 'none',
            fontSize: '0.4rem',
            '&:hover': {
                textDecoration: 'none'
            },
            '&:link': {
                textDecoration: 'none'
            }
        },
        exportIcon: {
            fontSize: '20px',
            fill: 'white'
        }
    })
);

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles(theme => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const CompleteOrderPageViewDate: React.StatelessComponent<CompleteOrderPageViewDateProps> = (props) => {
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px'
                },
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '0px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Received on',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px',
                    textAlign: 'center'
                },
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px'
                },
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Destination',
                field: 'destination',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px',
                    textAlign: 'center'
                },
            },
            {
                title: 'Completed On',
                field: 'completedon',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px',
                    textAlign: 'center'
                },
            },
            {
                title: 'View',
                field: 'orderno',
                export: false,
                render: rowData => (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {
                            rowData.vfiles !== '' ?
                                <Tooltip title="Video" placement="top">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.openVideoPlayerURL(rowData.vfiles.split(','), rowData.fpath)}
                                        aria-label="view video"
                                    >
                                        <PlayCircleFilledTwoToneIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                    </div>
                ),
                cellStyle: {
                    padding: '0px',
                    textAlign: 'center'
                }
            }

        ],
        data: props.completeOrderDataDate
    });

    const tableHeaders = [
        { label: 'Order No', key: 'orderno' },
        // { label: 'Booking ID', key: 'refno' },
        { label: 'Received on', key: 'orderdate' },
        { label: 'File Name', key: 'fname' },
        { label: 'TAT', key: 'tat' },
        { label: 'Destination', key: 'destination' },
        { label: 'Due By', key: 'dueby' },
        { label: 'Completed On', key: 'completedon' },
    ];

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [startDate, setStartDate] = React.useState<Date>(new Date());
    const [endDate, setEndDate] = React.useState<Date>(new Date());
    const [dayValidation, setDayValidation] = React.useState(false);

    const maxDayCount = (sdate: Date, edate: Date) => {
        if (Math.abs(sdate.getTime() - edate.getTime()) < (8 * 24 * 60 * 60 * 1000)) {
            return false;
        }
        return true;
    };

    const changeStartDate = (date: Date) => {
        setDayValidation(false);
        setStartDate(date);
    };
    const changeEndDate = (date: Date) => {
        setDayValidation(false);
        setEndDate(date);
    };

    // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const classes = useStyles({});

    const [dialogOpen, setdialogOpen] = React.useState(props.completeOrderDataDate.length > 0 ? false : true);

    const handleClickDialog = () => {
        setdialogOpen(true);
    };

    const handleCloseDialog = () => {
        setdialogOpen(false);
    };

    const submitDialog = () => {
        props.fDate(startDate);
        props.toDate(endDate);

        if (!maxDayCount(startDate, endDate)) {
            props.dateFilter();
            setdialogOpen(false);
        } else {
            setDayValidation(true);
        }
    };

    const resetDialog = () => {
        props.dateReset();
        setdialogOpen(false);
    };

    const [page, setPage] = React.useState(0);
    const [size, setSize] = React.useState(5);
    const [selectedRowsArray, setSelectedRowsArray] = React.useState<RowDataCompleted[]>([]);

    const handleSelectAll = (tableData: RowDataCompleted[]) => {
        setSelectedRowsArray(tableData.slice(page * size, (page * size) + size));
    };
    const handleSelectOne = (tableData: RowDataCompleted) => {

        if (tableData.orderno) {
            setSelectedRowsArray((items: RowDataCompleted[]) => {
                if (items.find(_d => _d.orderno === tableData.orderno)?.orderno) {
                    return items.filter((item) => item.orderno !== tableData.orderno);
                }
                const newItems = items.concat([tableData]);
                return newItems;
            });
        }

    };

    const [downIndi, setDownIndi] = React.useState(false);
    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [downloadType, setDownloadType] = React.useState('multiple');

    const openDownloadDialog = (rowdata: RowDataCompleted[] | RowDataCompleted, type: String) => {
        if (type === 'zip' && selectedRowsArray.length === 1) {
            props.onBulkDownload(selectedRowsArray);
        } else {
            if (type === 'zip') { setDownIndi(true); setDownloadType('multiple'); } else { setDownIndi(false); }
            setFileTypes([]);
            setOpenDownload(true);
        }
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };

    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(selectedRowsArray, fileTypes.toString());
    };
    const submitZipDownload = () => {
        setOpenDownload(false);
        if (downloadType === 'single') {
            props.onBulkDownload(selectedRowsArray);
        } else {
            props.onBulkDownloadIndividual(selectedRowsArray);
        }
    };

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Export" placement="top" arrow>
                            <Button
                                id="Export"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                className={classes.buttonSend}
                            >
                                <CSVLink
                                    data={props.completeOrderDataExport}
                                    // enclosingCharacter={``}
                                    headers={tableHeaders}
                                    filename={'Archive Orders Report.csv'}
                                    className={classes.exportButton}
                                // target="_blank"
                                >
                                    <FileCopyIcon className={classes.exportIcon} />
                                </CSVLink>
                            </Button>
                        </Tooltip>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleClickDialog}
                                className={classes.buttonSend}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <Dialog
                            open={dialogOpen}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title"><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Date Filter</Typography></DialogTitle>
                            <DialogContent>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <div className={classes.dialog}>
                                        <Grid container justify="space-around" spacing={2}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                label="Start Date"
                                                format="MM/dd/yyyy"
                                                value={startDate}
                                                onChange={changeStartDate}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                            <KeyboardTimePicker
                                                margin="normal"
                                                id="time-picker"
                                                label="Start Time"
                                                value={props.startTime}
                                                onChange={props.fTime}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                            />
                                        </Grid>
                                        <Grid container justify="space-around" spacing={2}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog-2"
                                                label="End Date"
                                                format="MM/dd/yyyy"
                                                value={endDate}
                                                onChange={changeEndDate}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                            <KeyboardTimePicker
                                                margin="normal"
                                                id="time-picker-2"
                                                label="End Time"
                                                helperText={dayValidation && 'Data not more than a week'}
                                                value={props.endTime}
                                                onChange={props.toTime}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                            />
                                        </Grid>
                                    </div>
                                </MuiPickersUtilsProvider>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.HeadinG}
                                    onClick={submitDialog}
                                >
                                    Submit
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={resetDialog}
                                    className={classes.HeadinG}
                                >
                                    Reset
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth
                            maxWidth="sm"
                        // maxWidth={!downIndi ? maxWidthDownload : 'md'}
                        >
                            <DialogTitle id="form-dialog-title">{!downIndi ? 'What to download?' : 'Download As'}</DialogTitle>
                            {!downIndi ?
                                <DialogContent dividers>
                                    <Grid container spacing={2}>
                                        {
                                            downloadFiletypes.map((typeFile, indexRe1) => (
                                                <Grid item key={indexRe1} xs={6} sm={4} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`filetype${indexRe1}`}
                                                                checked={fileTypes.indexOf(typeFile) > -1}
                                                                value={typeFile}
                                                                onChange={filetypeChange}
                                                                name="Filetype"
                                                            />
                                                        }
                                                        label={typeFile}
                                                    />
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </DialogContent>
                                : <DialogContent dividers>
                                    <Grid container spacing={2}>
                                        <RadioGroup aria-label="down-type" name="download-type" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
                                            <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" />
                                            <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                        </RadioGroup>
                                    </Grid>
                                </DialogContent>

                            }
                            <DialogActions>
                                {downloadType === 'single' && downIndi && <Typography variant="caption" >
                                    *Note: If selected file size exceeding 1 GB might not download properly, consider downloading as Individual files.
                                </Typography>}
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                {!downIndi && <Button size="small" onClick={submitStlDownload} color="primary">
                                    Download
                                </Button>}
                                {downIndi && <Button size="small" onClick={() => submitZipDownload()} color="primary">
                                    OK
                                </Button>}
                            </DialogActions>
                        </Dialog>
                        <StyledMenu
                            id="customized-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <StyledMenuItem key="1">
                                <ListItemIcon>
                                    <PictureAsPdfIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="PDF" />
                            </StyledMenuItem>
                            <StyledMenuItem key="2">
                                <ListItemIcon>
                                    <InsertDriveFileIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="CSV" />
                            </StyledMenuItem>
                            <StyledMenuItem key="3">
                                <ListItemIcon>
                                    <AssignmentIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="EXCEL" />
                            </StyledMenuItem>
                        </StyledMenu>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Archive"
                        columns={state.columns}
                        data={props.completeOrderDataDate}
                        localization={{
                            toolbar: {
                                nRowsSelected: `${selectedRowsArray.length} order(s) selected`,
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '0px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            sorting: false,
                            selectionProps: (selecrowData: RowDataCompleted) => {
                                const check = (selectedRowsArray.find(_d => _d.orderno === selecrowData.orderno)?.orderno) ? { checked: true } : { checked: false };
                                return {
                                    ...check
                                };
                            }
                        }}
                        onSelectionChange={
                            (rows, rowData) => {
                                if (!rowData) {
                                    handleSelectAll(rows);
                                } else {
                                    handleSelectOne(rowData);
                                }
                            }
                        }
                        onChangePage={
                            (pageno) => {
                                setPage(pageno);
                            }
                        }
                        onChangeRowsPerPage={
                            (pageSize) => {
                                if (pageSize !== size) {
                                    if (pageSize > size) {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) - pageSize, props.completeOrderDataDate.length / 5), 0)));
                                    } else {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) + pageSize, props.completeOrderDataDate.length / 5), 0)));
                                    }
                                }
                                setSize(pageSize);
                            }
                        }
                        actions={[
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download Zip
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'zip');
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download STL/PTS/3OX
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download STL/PTS/3OX files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'stl');
                                    }
                                }
                            }
                            // {
                            //     icon: 'save_alt' ,
                            //     tooltip: 'Export',
                            //     isFreeAction: false,
                            //     onClick: (event, rowData) => {
                            //         // ==> console.error(rowData);
                            //     }
                            // },
                            // {
                            //     tooltip: 'Download All files',
                            //     icon: 'view_column',
                            //     isFreeAction: true,
                            //     onClick: (evt, data) => {
                            //         if (!props.isDownloading) {
                            //             props.onBulkDownload(props.completeOrderDataDate);
                            //         }
                            //     }
                            // }
                        ]}
                    />
                </Grid>
            </Grid>
        </div >
    );
};

export default CompleteOrderPageViewDate;



// WEBPACK FOOTER //
// ./src/components/layouts/CompleteOrderPageViewDate.tsx